import i18n, { i18nReady } from '../../../i18n';

import desktopEn from './desktop.en.json';
import desktopIt from './desktop.it.json';

let didRegister = false;

export const registerDesktopTranslations = () => {
  if (didRegister) return;
  didRegister = true;

  i18nReady.then(() => {
    i18n.addResourceBundle('it', 'mobile', desktopIt, true, false);
    i18n.addResourceBundle('en', 'mobile', desktopEn, true, false);
  });
};

